<template>
    <nav id="top-bar" class="main-navbar container-h-lg bg-color-primary">
        <a href="/dashboard"
           class="navbar-brand flex-shrink-0"
           v-bind:style="seasonalBrand !== null ? seasonalBrand : ''"
        >DossierData</a>

        <div class="flex-row w-100 z-auto bg-primary align-items-center justify-content-end h-100">
            <search-bar-wrapper-component
                v-if="showSearch"
                v-bind:isSmallScreen="isSmallScreen"
                ref="searchComponent"
                class="m-auto"
            ></search-bar-wrapper-component>

            <ul ref="navlinks" class="nav-links">
                <li v-if="isSmallScreen && showSearch" class="mobile-search-icon" @click="toggleSearchModal">
                    <nav-link title="Zoeken...">
                        <MagnifyIcon title=""></MagnifyIcon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Dossiers" href="/dashboard/customers">
                        <account-icon title=""></account-icon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Leads" href="/dashboard/leads">
                        <target-account-icon title=""></target-account-icon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Relaties" href="/dashboard/relations">
                        <!-- TODO: Consider using material resistor-nodes icon instead -->
                        <!-- TODO: Consider using material graph icon instead -->
<!--                        <resistor-nodes-icon title=""></resistor-nodes-icon>-->
                        <account-network-icon title=""></account-network-icon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Taken" href="/dashboard/tasks">
                        <checkbox-outline-icon title=""></checkbox-outline-icon>
                    </nav-link>
                </li>

                <li v-if="showSignals">
                    <nav-link title="Signalen" href="/dashboard/signals">
                        <BellIcon title=""/>
                    </nav-link>
                </li>

                <li v-if="showSelections">
                    <nav-link title="Selecties" href="/dashboard/selections">
                        <selection-multiple-icon title=""></selection-multiple-icon>
                    </nav-link>
                </li>

                <li>
                    <nav-link title="Rentes" href="/dashboard/tools">
                        <sack-percent-icon title=""></sack-percent-icon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Email" href="/dashboard/email">
                        <email-icon title=""></email-icon>
                    </nav-link>
                </li>
                <li>
                    <nav-link title="Agenda" href="/dashboard/calendar">
                        <calendar-month-icon title=""></calendar-month-icon>
                    </nav-link>
                </li>
                <li v-if="showReporting">
                    <nav-link title="Rapportage" href="/dashboard/reporting">
                        <file-chart-icon title=""></file-chart-icon>
                    </nav-link>
                </li>
                <!-- Terugbelverzoeken -->
                <phone-dropdown-component
                        v-if="me"
                        :userTasks="userTasks"
                        :departmentTasks="departmentTasks"
                        :departments="departments"
                ></phone-dropdown-component>
            </ul>
            <profile-dropdown-component
                    :avatar="avatar"
            ></profile-dropdown-component>
        </div>
    </nav>
</template>
<script>
import SearchBarWrapperComponent from './SearchBarWrapperComponent.vue'
import ProfileDropdownComponent from './ProfileDropdownComponent.vue'
import PhoneDropdownComponent from './PhoneDropdownComponent.vue'
import NavLink from './NavLink.vue'
import { mapActions, mapState } from 'vuex';

export default {
  name: 'MainNavbarComponent',
  components: {
    NavLink,
    ProfileDropdownComponent,
    SearchBarWrapperComponent,
    PhoneDropdownComponent
  },
  props: {
    avatar: {
      type: String,
      required: false,
      default() {
        return "assets/img/blank_avatar.png";
      },
    },
    userTasks: {
      type: Array,
      required: false,
      default: () => [],
    },
    departmentTasks: {
      type: Array,
      required: false,
      default: () => [],
    },
    departments: {
      type: Array,
      required: false,
      default: () => [],
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    showSignals: {
        type: Boolean,
        default: false,
    },
    showSelections: {
        type: Boolean,
        default: false,
    },
    showReporting: {
        type: Boolean,
        default: false,
    }
  },
  data () {
    return {
      iconSize: 24,
      iconColor: '#447bc9',
      dashboardUrl: '#',
      navLinksOffsetWidth: 0,
      searchBarOffsetWidth: 0,
      searchBarWidth: 0,
      screenWidth: 0,
    }
  },
  computed: {
    ...mapState({
      me: 'me',
    }),
    isSmallScreen () {
      const vh = this.screenWidth / 100;
      this.searchBarOffsetWidth = 50 * vh + (this.searchBarWidth / 2);
      return (this.navLinksOffsetWidth + this.searchBarOffsetWidth) > this.screenWidth;
    },
    seasonalBrand () {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;

      if (month === 12 && day >= 24 && day <= 31) {
        return {
          backgroundImage: `url('/img/dossierdata-logo-christmas.svg') !important`,
        }
      }

      return null;
    },
  },
  methods: {
    toggleSearchModal () {
      if (this.$refs.searchComponent.openModal) {
        return this.$refs.searchComponent.closeSearchModal()
      }
      return this.$refs.searchComponent.openSearchModal()
    },
    onWidthChange () {
      this.screenWidth = window.innerWidth;
    },
    defineElementWidthConstants () {
      const searchBar = document.getElementById('search-wrapper');
      if (!searchBar) return;
      this.searchBarWidth = searchBar.offsetWidth
      const padding = 88;
      this.navLinksOffsetWidth = this.$refs.navlinks.offsetWidth + padding
    },
    ...mapActions({
      getMe: 'getMe',
    })
  },
  created() {
    this.getMe();
  },
  mounted () {
    this.defineElementWidthConstants()
    window.addEventListener('resize', this.onWidthChange)
    this.onWidthChange()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWidthChange)
  },
}
</script>

<style lang="scss" scoped>

@use "sass:map";
@import "~@/_default.scss";


.has-sidebar .main-navbar {
  width: 100%;
}

.main-navbar {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: width .2s ease-in-out;
}

ul.nav-links {
  color: white;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style-type: none;
  padding: 0 $spacing-md;
  height: $navbar-height;
  li {
    display: flex;
    place-content: center;
    height: 100%;
    width: 40px;
      &:has(a.active){
          border-bottom-width: 3px;
          border-bottom-color: $color-white;
          border-bottom-style: solid;
      }
  }
}
</style>
